import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'

const HeartEmoji = (props: IIconProps) => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx="12" cy="12" r="12" fill="#F26752" />
      <path
        fill="#FFF"
        d="M17.15 8.344c-.567-.563-1.35-.844-2.351-.844-.277 0-.56.049-.847.146a3.4 3.4 0 0 0-.804.395c-.247.165-.46.32-.64.466-.178.145-.347.3-.508.463a6.23 6.23 0 0 0-.509-.463 8.6 8.6 0 0 0-.64-.466 3.406 3.406 0 0 0-.803-.395A2.633 2.633 0 0 0 9.2 7.5c-1 0-1.784.281-2.35.844C6.282 8.906 6 9.686 6 10.684c0 .304.053.617.157.94.105.321.225.596.359.822.134.227.285.448.455.664.17.215.294.364.372.445.078.082.14.141.184.177l4.178 4.096c.08.082.179.172.295.172.116 0 .214-.09.295-.172l4.172-4.082C17.489 12.707 18 11.686 18 10.684c0-.998-.284-1.778-.85-2.34z"
      />
    </g>
  </BaseIcon>
)

export default HeartEmoji
